import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchCountryListModule } from "./helpAndAssistantApi";

export interface CountryListState {
  countrylist: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: CountryListState = {
    countrylist: [],
  status: "idle",
};

export const GetCountryList = createAsyncThunk(
  "countryList/fetchCountry",
  async () => {
    const response = await fetchCountryListModule();
    return response;
  }
);

export const countryListSlice = createSlice({
  name: "countryList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetCountryList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetCountryList.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetCountryList.fulfilled, (state, action) => {
        state.status = "idle";
        state.countrylist = action.payload;
      });
  },
});

export const {} = countryListSlice.actions;

export const selectCountryList = (state: RootState) => {
  return state.CountryList.countrylist;
};

export default countryListSlice.reducer;
